import moduleDescriptions from 'root/src/shared/descriptions/modules'
import { listModuleLenses } from 'root/src/client/logic/list/lenses'

const { viewListControls } = listModuleLenses

export default (state, { moduleId }) => viewListControls(moduleId, moduleDescriptions)
